import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageEEG6 } from "../StartPage.types";

function useStartPageEEG6(bookable: boolean, year: number, projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.eeg6.key(year, projectId),
    queryFn: () => fetchStartPageEEG6(year, projectId),
    enabled: !bookable
  });

  return { data, error, isLoading };
}

async function fetchStartPageEEG6(year: number, projectId?: string) {
  const response = await apiWithoutCamelization.get<StartPageEEG6>(
    urls.startPage.eeg6.url(year, projectId)
  );
  return response.data;
}

export { useStartPageEEG6 };
